module.exports = __webpack_public_path__ + "assets/img/topImg2.91d53082.png";